export default __webpack_public_path__ + "static/B0079-0c0c2a1ed2ad74e250b183096aaf22b2.png";